import { useEffect } from 'react';
import { listenOrder } from '../../channels/orderChannel';
import { useOrderStore } from '../../stores/useOrderStore';

export function useOrderChannel() {

    useEffect(() => {

        const unsubscribe = listenOrder(({ tipo, payload }) => {

            const {
                setOrder,
                setOrderASC
            } = useOrderStore.getState();

            if (tipo === 'order-upsert') {

                setOrder(payload, false);

            }

            if (tipo === 'order-asc-upsert') {
                
                setOrderASC(payload, false);

            }


        });

        return unsubscribe;

    }, []);

}